import getContentReader from "../../../utils/getContentReader";
import TerminalPageTemplate from "../../shared/TerminalPageTemplate";
import userImage from "../../../assets/user.svg";
import usePageTitle from "../../../utils/hooks/usePageTitle";
import useStore from "../../../store/store";
import LoadingSpinnerPage from "../../shared/LoadingSpinnerPage";

const DecisionAdditionalTime = () => {
  usePageTitle("Decision/Additional Time Needed");

  const pageContent = useStore(({ content }) =>
    content
      .flatMap(bundle => bundle?.postSubmitTreatments?.postSubmitErrors ?? [])
      .find(({ contentId }) => contentId === "5xxAutoRetryErrors")
  );

  if (!pageContent) {
    return <LoadingSpinnerPage />;
  }

  return (
    <TerminalPageTemplate image={userImage} readContent={getContentReader(pageContent)} showCEMPSurvey />
  );
};

export default DecisionAdditionalTime;
